import React from "react";
import { Alert, AlertTitle, Box } from "@mui/material";
import BuildCircleOutlinedIcon from "@mui/icons-material/BuildCircleOutlined";

/**
 * Aviso de mantenimiento programado del módulo High Cost.
 * Visible en todos los dashboards del Main mientras dure la ventana.
 *
 * Para retirar el banner cuando el módulo vuelva online: borrar el
 * <HighCostMaintenanceBanner/> de MainPage.jsx (1 línea).
 */
const HighCostMaintenanceBanner = () => (
  <Box sx={{ mb: 2 }}>
    <Alert
      severity="warning"
      icon={<BuildCircleOutlinedIcon />}
      sx={{ alignItems: "center" }}
    >
      <AlertTitle sx={{ fontWeight: 700, mb: 0.5 }}>
        High Cost module — scheduled maintenance
      </AlertTitle>
      The High Cost module is temporarily offline today and tomorrow while
      we run an optimization process. Service will resume automatically once
      the work is complete. Thanks for your patience.
    </Alert>
  </Box>
);

export default HighCostMaintenanceBanner;
